<template>
  <div class="esterno">
    <img alt="logo" src="../assets/logo.png" class="logo" />
    <!-- <br />
    <router-link style="text-decoration: none; color: inherit;" :to="{ name: 'Oscars'}">
      <h5 class="display-5">Classifica del FantaOscar!</h5>
    </router-link> -->
    <br />
    <h5 class="display-4">Ascolta l'ultima puntata!</h5>
    <!-- Ultima puntata -->
    <iframe
      :src="
        totale(
          $store.getters['episodi'][$store.getters['episodi'].length - 1].codice
        )
      "
      width="60%"
      height="500"
      frameBorder="0"
      allowfullscreen=""
      allow="autoplay; clipboard-write; encrypted-media; 
        fullscreen; picture-in-picture"
      class="last_puntata"
    ></iframe>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";

export default {
  name: "Home",
  components: {},
  setup() {
    let parte1 = "https://open.spotify.com/embed/episode/";
    let parte2 = "?utm_source=generator&theme=0";

    const totale = (_link) => {
      return parte1 + _link + parte2;
    };

    return {
      totale,
    };
  },
};
</script>

<style>
.logo {
  /* width:"400";
  height:"400"; */
  --max-height: 300px;
  /* Set a baseline width for your element */
  width: 60%;
  /* And limit it with our function above */
  max-width: calc(var(--max-height, 300px) * var(--img-ratio, 1));
}

.last_puntata {
  --max-height: 320px;
  /* Set a baseline width for your element */
  width: 85%;
  /* And limit it with our function above */
  max-width: calc(var(--max-height, 300px) * var(--img-ratio, 2));
}
.esterno {
  margin-top: 12%;
}

.display-4 {
  color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 5px 5px;
  /* border: 2px solid #961313; */
  border-radius: calc(10px);
  background: #2c3e50;
  width: 80%;
  margin-left: 10%;
  padding: 1%;
  margin-bottom: 2%;
  font-weight: 550;
}

.display-5 {
  color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 5px 5px;
  /* border: 2px solid #961313; */
  border-radius: calc(10px);
  background: #490234;
  width: 80%;
  margin-left: 10%;
  padding: 1%;
  margin-bottom: 2%;
  font-weight: 550;
  cursor: pointer;
  text-decoration: none;
}
@media screen and (max-width: 1000px) {
  .last_puntata {
    width: 95%;
    --max-height: 500px;
    max-width: calc(var(--max-height, 300px) * var(--img-ratio, 2));
  }
}
@media screen and (max-width: 540px) {
  .esterno {
    margin-top: 40%;
  }
  .display-4 {
    margin-bottom: 4%;
  }
  .display-5 {
    margin-bottom: 4%;
  }
}
@media screen and (max-width: 850px) and (min-width: 540px) {
}

@media screen and (min-width: 850px) and (max-width: 1000px) {
}
</style>
